jQuery(document).ready(function($) {


	// ---------------------------------------------------------------------
	// | modal subscribe                                                   |
	// ---------------------------------------------------------------------
	if ($('.jsSubscribeModal').length) {

		// load subscribe modal after n seconds if no subscribed cookie
		//------------------------------------------------------------
		function getCookie(cname) {
			var name = cname + '=';
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return '';
		}

		function setCookie(cname, cvalue, exdays, trigger) {
			var d = new Date();
			d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
			var expires;
			if (trigger === 'close') {
				expires = 'expires=' + d.toUTCString();
			} else if (trigger === 'submit') {
				// maximum date for cookie expiry
				// https://stackoverflow.com/questions/532635/javascript-cookie-with-no-expiration-date
				expires = 'expires=' + 2147483647;
			}
			document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
		}

		var url = window.location.hostname.replace(/\./g,'');
		var cookieName = url + '-SubscribeModal';
		var modalTimer = $('#modalTimer').val();

		$('.jsSubscribeModal').on('hidden.bs.modal', function() {
			if (getCookie(cookieName) === '') {
				setCookie(cookieName, 'close', 1, 'close');
			}
		});

		if (getCookie(cookieName) === '') {
			window.setTimeout(function() {
				$('.jsSubscribeModal').modal('show');
			}, modalTimer);
		}

		// hide bg image after submit and set cookie
		$('.jsSubscribeModal .btn').on('click', function() {
			var checkForSuccess = setInterval(function() {
				if ($('.form-submission-message').length) {
					clearInterval(checkForSuccess);
					$('.jsSubscribeModal .modal-content').addClass('submitted');
					setCookie(cookieName, 'close', 1, 'submit');
				}
			}, 100);
		});


	}
});
